// extracted by mini-css-extract-plugin
export default {"login-form":"login_login-form__VN6YQ","login-form__sub-text":"login_login-form__sub-text__15Cab","login-form__button":"login_login-form__button__gExlw"};